<template>
	<div class="column-input">
		<div class="prefix-icons">
			<span>
				<ColumnSvg />
			</span>
			<span class="pl-2">
				<NumberSvg />
			</span>
		</div>
		<!-- pass $attrs to child means pass all attributes of component that arent explicit declare as props -->
		<RichTextBox v-on="$listeners" v-bind="$attrs" readonly :ref="RICH_EDITOR_REFERENCE_NAME" />
		<div class="suffix-icons">
			<span @click="$emit('click')">
				<DropdownArrowSvg :class="['dropdown-icon', { 'dropdown-open': isDropdownOpen }]" />
			</span>
		</div>
	</div>
</template>

<script>
import ColumnSvg from './assets/ColumnSvg';
import NumberSvg from './assets/NumberSvg';
import DropdownArrowSvg from './assets/DropdownArrowSvg';
import InputComponentMixinBase from './mixins/InputComponentMixinBase';
export default {
	name: 'TableColumnNumberDropdownInput',
	props: { isDropdownOpen: { type: Boolean } },
	mixins: [InputComponentMixinBase],
	components: { ColumnSvg, NumberSvg, DropdownArrowSvg },
};
</script>
<style lang="scss" scoped>
.column-input {
	position: relative;

	.prefix-icons {
		position: absolute;
		top: 6px;
		left: 15px;
		z-index: 1;
	}

	.suffix-icons {
		position: absolute;
		top: 6px;
		right: 10px;
		z-index: 1;
		.dropdown-icon {
			transition: 0.2s transform;
			&.dropdown-open {
				transform: rotateX(180deg);
			}
		}
	}

	::v-deep {
		.ProseMirror {
			padding-left: 40px;
			padding-right: 25px;

			.is-empty {
				margin-left: -5px;
				margin-right: -5px;
			}
		}
	}
}
</style>
